import { isFuture } from "date-fns";

import {
  FREQUENCIES,
  generateRecurrenceRuleString,
} from "../../../../Recurrence";

import { API as LoanPaymentAPI } from "./api";

import type { LoanPaymentFormValues } from "./types";
import type { NetworkPayload } from "../../../composites/request/request.types";

export const getLoanPaymentRequest = (
  idempotencyKey: string | undefined,
  formValues: LoanPaymentFormValues,
  userId: API.UserId,
): NetworkPayload => {
  const {
    amount,
    cardUUID,
    fundingMethod,
    toAccountId,
    fromAccountId,
    frequency,
    date,
    fromAccountSource,
    paymentType,
  } = formValues || {};

  if (cardUUID && fundingMethod === "card") {
    return LoanPaymentAPI.makeCardLoanPayment(
      {
        amount,
        account_uuid: toAccountId,
        userfunding_uuid: cardUUID,
      },
      userId,
    );
  }

  // set by the form upon selecting a "from" account.
  if (!fromAccountId || !fromAccountSource) {
    throw new Error(
      "no fromAccountId or fromAccountSource provided for transfer source account",
    );
  }

  if ((isFuture(date) || frequency !== "ONCE") && fromAccountId) {
    const frequencyValue = frequency
      ? FREQUENCIES[frequency]
      : FREQUENCIES.ONCE;
    return LoanPaymentAPI.makeScheduledTransfer({
      amount,
      to_account_id: toAccountId,
      from_account_id: fromAccountId,
      recurring_rule: generateRecurrenceRuleString(frequencyValue, date),
      agreement: true,
      ...(idempotencyKey ? { idempotencyKey } : {}),
    });
  }

  const paymentTypeParam =
    paymentType === "principal" ? paymentType : "default";

  if (fromAccountSource === "external" && fromAccountId) {
    return LoanPaymentAPI.makeExternalLoanPayment({
      amount,
      fromAccountSource,
      payment_type: paymentTypeParam,
      to_account: toAccountId,
      from_account: fromAccountId,
    });
  }

  return LoanPaymentAPI.makeInternalLoanPayment({
    amount,
    payment_type: paymentTypeParam,
    to_account: toAccountId,
    from_account: fromAccountId,
  });
};
